import { setUnifiedError, removeUnifiedError } from "../../partnerCentralUtils";
export default class Helper {
  constructor(context) {
    this.context = context;
  }

  getContext() {
    return this.context;
  }

  getContainer(clientContext) {
    return clientContext.uiContainer;
  }

  getUserNameFromClientContext(clientContext) {
    return clientContext.username == undefined
      ? "Anonymous"
      : clientContext.username;
  }

  clearContainer(clientContext) {
    if (this.getContainer(clientContext) != undefined)
      this.getContainer(clientContext).innerHTML = "";
  }

  getCustomContainer(clientContext) {
    let container = document.createElement("div");

    let journey = document.getElementById("journey").value;
    let journeyTitle;
    if ("forgot_password_userless" === journey)
      journeyTitle = "Forgot Password";
    else if ("password_and_otp_auth" === journey) journeyTitle = "Authenticate";
    else if ("self_registration" === journey)
      journeyTitle = "Self Registration";
    else if ("change_qa" === journey) journeyTitle = "Change/Forgot QA";
    else if ("change_password" === journey) journeyTitle = "Change Password";

    let header = document.createElement("h3");
    header.classList.add("bg-primary");
    header.textContent = journeyTitle;

    return container;
  }

  createButtonGroup(buttonArray) {
    let buttonGroupDiv = document.createElement("div");
    buttonGroupDiv.classList.add("table-responsive");

    let table = document.createElement("table");
    table.classList.add("table");
    let row = document.createElement("tr");

    buttonArray.forEach((button) => {
      let cell = document.createElement("td");
      cell.classList.add("text-center");
      cell.appendChild(button);
      row.appendChild(cell);
    });

    table.appendChild(row);
    buttonGroupDiv.appendChild(table);
    return buttonGroupDiv;
  }

  presentSelectionUI(items, instructions, cancelRequest, clientContext) {
    const menuForm = document.querySelector("#email-cta")
    return new Promise((resolve, reject) => {

      let sendOTPButton = document.getElementById("send-otp");

      if (sendOTPButton) {
        sendOTPButton.onclick = () => {
          const selectedIndexValue = document.querySelector("#selected-target-index").textContent
          const selectedValue = items[selectedIndexValue].value
          resolve(selectedValue)
        };

        if (cancelRequest) {
          const cancelButtonArr = Array.from(document.querySelectorAll("#dt-back-button, #mb-ct-back-button"))
          cancelButtonArr.forEach(cancelButton => {
            cancelButton.onclick = () => {
              resolve(cancelRequest)
              document.querySelector("#sign-in-container").className = "show-provide-email-password"
              document.querySelector("#history-back-button").classList.remove("hidden")
            }
          })
        }
        this.presentUI(menuForm, clientContext);
      }

      else {
        resolve(items[0].value)
      }

    });
  }

  creatFormInputAndLabel(inputArray) {
    let inputDiv = document.createElement("div");
    inputDiv.classList.add("table-responsive");

    let table = document.createElement("table");
    table.classList.add("table");

    inputArray.forEach((input) => {
      let row = document.createElement("tr");
      let label_cell = document.createElement("td");
      label_cell.classList.add("text-center");

      let label = document.createElement("label");
      label.textContent = input.label;

      label_cell.appendChild(label);

      let input_cell = document.createElement("td");
      let input_el = document.createElement("input");
      input_el.classList.add("form-control");
      input_el.setAttribute("id", input.id);
      input_el.setAttribute("type", input.type);

      input_cell.appendChild(input_el);

      row.appendChild(label_cell);
      row.appendChild(input_cell);

      table.appendChild(row);
    });

    inputDiv.appendChild(table);

    return inputDiv;
  }

  presentUI(htmlElement, clientContext) {
    this.clearContainer(clientContext);
    let transmitContainer = this.getContainer(clientContext);

  }
}
